export default __webpack_public_path__ + "static/5-ecfb96671c3f6dea1979114c0381c6fe.jpg";